// Deterministic color palette for avatars
const PALETTE = [
  ['#1d4ed8', '#eff6ff'],
  ['#059669', '#d1fae5'],
  ['#d97706', '#fef3c7'],
  ['#7c3aed', '#ede9fe'],
  ['#dc2626', '#fee2e2'],
  ['#0891b2', '#cffafe'],
  ['#be185d', '#fce7f3'],
  ['#065f46', '#d1fae5'],
];

export function getAvatarColors(name = '') {
  const idx = name.split('').reduce((s, c) => s + c.charCodeAt(0), 0) % PALETTE.length;
  return PALETTE[idx]; // [fg, bg]
}

export function getInitials(name = '') {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() || '')
    .join('');
}

// Category → visual config for product images
const CATEGORY_ICONS = {
  impurity: {
    bg: ['#eff6ff', '#dbeafe'],
    accent: '#1d4ed8',
    label: 'IMP',
  },
  reference_standard: {
    bg: ['#f0fdf4', '#dcfce7'],
    accent: '#16a34a',
    label: 'RS',
  },
  default: {
    bg: ['#faf5ff', '#ede9fe'],
    accent: '#7c3aed',
    label: 'STD',
  },
};

export function getCategoryConfig(category = '') {
  return CATEGORY_ICONS[category] || CATEGORY_ICONS.default;
}
